export default {
  'en-US': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    },
    dateTime: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    dayMonthHour: {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    dayMonth: {
      month: 'short',
      day: 'numeric'
    },
    monthYear: {
      year: 'numeric',
      month: 'short'
    },
    monthYearNum: {
      year: 'numeric',
      month: 'numeric'
    },
    dayMonthYearNum: {
      year: 'numeric',
      day: 'numeric',
      month: 'numeric'
    },
    year: {
      year: 'numeric'
    }
  },
  'pt-BR': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
    dateTime: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
    dayMonthHour: {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    dayMonth: {
      month: 'short',
      day: 'numeric'
    },
    monthYear: {
      year: 'numeric',
      month: 'short'
    },
    monthYearNum: {
      year: 'numeric',
      month: 'numeric'
    },
    dayMonthYearNum: {
      year: 'numeric',
      day: 'numeric',
      month: 'numeric'
    },
    year: {
      year: 'numeric'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/dateTimeFormats.js